export const SEVERITY_ORDER = {
    critical: 1,
    high: 2,
    medium: 3,
    low: 4,
    info: 5,
};
export const SEVERITY_COLORS = {
    critical: '#dc2626', // red-600
    high: '#ea580c', // orange-600
    medium: '#ca8a04', // yellow-600
    low: '#2563eb', // blue-600
    info: '#6b7280', // gray-500
};
export const SEVERITY_LABELS = {
    critical: 'Critical - Fix immediately',
    high: 'High - Fix soon',
    medium: 'Medium - Should fix',
    low: 'Low - Consider fixing',
    info: 'Info - Good to know',
};
export const CATEGORY_LABELS = {
    'ssl-tls': 'SSL/TLS & Encryption',
    'security-headers': 'Security Headers',
    network: 'Network & Ports',
    injection: 'Injection Attacks',
    xss: 'Cross-Site Scripting',
    authentication: 'Authentication',
    configuration: 'Misconfiguration',
    'information-disclosure': 'Information Leaks',
    csrf: 'Cross-Site Request Forgery',
    'path-traversal': 'Path Traversal',
    'command-injection': 'Command Injection',
    'access-control': 'Access Control',
    'api-security': 'API Security',
    other: 'Other',
};
export function emptyFindingCounts() {
    return { critical: 0, high: 0, medium: 0, low: 0, info: 0, total: 0 };
}
export function calculateHealthScore(counts) {
    // Weighted scoring: critical=25, high=15, medium=5, low=2, info=0
    const penalty = counts.critical * 25 + counts.high * 15 + counts.medium * 5 + counts.low * 2;
    return Math.max(0, Math.min(100, 100 - penalty));
}
//# sourceMappingURL=finding.js.map